import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'DesktopSearchField' })({
    container: {
        display: 'flex',
        padding: '10px 16px 10px 20px',
        background: '#F0F3F4',
        borderRadius: 16,
        position: 'relative',
        gap: 16,
        flexDirection: 'row',
        alignItems: 'center',
        width: '100%'
    },
    vertical: {
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 8
    },
    buttonGroup: {
        color: '#8385A3',
        display: 'flex',
        alignItems: 'center',
        gap: 16
    },
    button: {
        paddingTop: 8.5,
        paddingBottom: 8.5,
        border: 0
    },
    searchFieldRoot: {
        flex: 1,
        boxSizing: 'border-box',
        position: 'relative'
    },
    searchFieldList: {
        top: '100%',
        left: 0,
        right: 0
    },
    typeFieldRoot: {
        boxSizing: 'border-box',

        width: 121
    },
    typeFieldList: {
        top: '100%',
        left: 0
    },
    divider: {
        margin: 'auto 0',
        height: 16,
        background: '#DDDEF1'
    }
});
